import { JSX } from "react";
import { ProductCarousel } from "@hatch-digital-nl/bravilor-storybook";
import { Image } from "../../../common/interfaces/ProductDetailsDataInterface";

interface Props {
    isLoading: boolean;
    images: Image[];
    onImageClick: (images: Image[]) => void;
}

export const ProductDetailsCarousel = ({
    isLoading,
    images,
    onImageClick,
}: Props): JSX.Element => {
    const imageCount = isLoading ? 0 : images.length;

    return (
        <ProductCarousel
            loading={isLoading}
            images={images}
            offlineImages={true}
            onImageClick={() => onImageClick(images)}
            lazyLoad={true}
            carouselKey={imageCount}
        />
    );
};
